module.exports = __webpack_public_path__ + "static/img/lefttop.2aabb11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/lefttop.png
// module id = WZw/
// module chunks = 0